import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import FloorPlansPage from '../pages/floor-plans/page';
import FloorPlan21Page from '../pages/floor-plans/2-1/page';
import FloorPlan31Page from '../pages/floor-plans/3-1/page';
import FloorPlan31TerracePage from '../pages/floor-plans/3-1-terrace/page';
import FloorPlan41Page from '../pages/floor-plans/4-1/page';
import FloorPlan21GardenPage from '../pages/floor-plans/2-1-garden/page';
import FloorPlan31DuplexPage from '../pages/floor-plans/3-1-duplex/page';
import GalleryPage from '../pages/gallery/page';
import ContactPage from '../pages/contact/page';
import ServicesPage from '../pages/services/page';
import CatalogPage from '../pages/catalog/page';
import RequestFormPage from '../pages/request-form/page';
import AdminLogin from '../pages/admin/Login';
import AdminLayout from '../pages/admin/AdminLayout';
import Dashboard from '../pages/admin/Dashboard';
import HomePageManager from '../pages/admin/HomePageManager';
import AboutPageManager from '../pages/admin/AboutPageManager';
import ServicesManager from '../pages/admin/ServicesManager';
import GalleryManager from '../pages/admin/GalleryManager';
import FloorPlansManager from '../pages/admin/FloorPlansManager';
import CatalogManager from '../pages/admin/CatalogManager';
import ProjectsManager from '../pages/admin/ProjectsManager';
import ContactManager from '../pages/admin/ContactManager';
import PartnersManager from '../pages/admin/PartnersManager';
import Messages from '../pages/admin/Messages';
import Settings from '../pages/admin/Settings';
import ProtectedRoute from '../components/ProtectedRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/floor-plans',
    element: <FloorPlansPage />,
  },
  {
    path: '/floor-plans/2-1',
    element: <FloorPlan21Page />,
  },
  {
    path: '/floor-plans/3-1',
    element: <FloorPlan31Page />,
  },
  {
    path: '/floor-plans/3-1-terrace',
    element: <FloorPlan31TerracePage />,
  },
  {
    path: '/floor-plans/4-1',
    element: <FloorPlan41Page />,
  },
  {
    path: '/floor-plans/2-1-garden',
    element: <FloorPlan21GardenPage />,
  },
  {
    path: '/floor-plans/3-1-duplex',
    element: <FloorPlan31DuplexPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/catalog',
    element: <CatalogPage />,
  },
  {
    path: '/request-form',
    element: <RequestFormPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'homepage',
        element: <HomePageManager />,
      },
      {
        path: 'about',
        element: <AboutPageManager />,
      },
      {
        path: 'services',
        element: <ServicesManager />,
      },
      {
        path: 'gallery',
        element: <GalleryManager />,
      },
      {
        path: 'floorplans',
        element: <FloorPlansManager />,
      },
      {
        path: 'catalog',
        element: <CatalogManager />,
      },
      {
        path: 'projects',
        element: <ProjectsManager />,
      },
      {
        path: 'partners',
        element: <PartnersManager />,
      },
      {
        path: 'contact-settings',
        element: <ContactManager />,
      },
      {
        path: 'messages',
        element: <Messages />,
      },
      {
        path: 'settings',
        element: <Settings />,
      }
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
